import React, { Component } from 'react'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardActions from '@mui/material/CardActions'
import CardHeader from '@mui/material/CardHeader'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid'
import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import { Alert, AlertTitle, Box, Collapse, Snackbar } from '@mui/material'
import HandymanIcon from '@mui/icons-material/Handyman'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import LockIcon from '@mui/icons-material/Lock'
import SendIcon from '@mui/icons-material/Send'
import SyncIcon from '@mui/icons-material/Sync'
import PointOfSaleIcon from '@mui/icons-material/PointOfSale'
import Table from '@mui/material/Table'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import RefreshIcon from '@mui/icons-material/Refresh'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'

const session = require('../../config/session')
const RestTunel = require('../../libs/rest_tunnel')

const intervaloCheckLoginAperturaState = 10000

// Etiquetas amigables para las acciones de actualizacion del depositario.
const labelDepositario = {
  actualizar_funcionarios: 'Funcionarios',
  actualizar_clientes: 'Depositantes',
  actualizar_entidades: 'Entidades'
}

class CajerosAccionesRemotas extends Component {

  constructor(props) {
    super(props)

    this.idCajero = props.location.state.id_cajero

    this.state = {
      cajero: {},
      accionesRemotas: [],
      enviandoActualizacion: false,
      modalPasswordOpen: false,
      passwordInput: '',
      passwordError: '',
      verificandoPassword: false,
      accionPassword: null,
      mostrarAlerta: false,
      mensajeAlerta: '',
      severidadAlerta: 'info'
    }

    this.cambiarEstadoOperativo = this.cambiarEstadoOperativo.bind(this)
    this.autorizarApertura = this.autorizarApertura.bind(this)
    this.checkLoginAperturaState = this.checkLoginAperturaState.bind(this)
    this.actualizarDatosDepositario = this.actualizarDatosDepositario.bind(this)
    this.queryAccionesRemotas = this.queryAccionesRemotas.bind(this)
  }

  componentDidMount() {
    this.queryCajero()
    this.queryAccionesRemotas()

    // Refresca el estado de autorizacion de apertura periodicamente (el cajero
    // consume login_autorizado al entrar el transportador, asi que la UI debe
    // reflejar cuando se "gasta").
    if (session.checkPermiso('opcion_activar_apertura_cajero')) {
      this.checkLoginAperturaState()
      this.timerRefrescarLoginApertura = setInterval(this.checkLoginAperturaState, intervaloCheckLoginAperturaState)
    }
  }

  componentWillUnmount() {
    clearInterval(this.timerRefrescarLoginApertura)
  }

  handleCloseAlert = (event, reason) => {
    if (reason === 'clickaway') return
    this.setState({ mostrarAlerta: false })
  }

  alerta(mensaje, severidad) {
    this.setState({ mostrarAlerta: true, mensajeAlerta: mensaje, severidadAlerta: severidad })
  }

  queryCajero() {
    var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: { id_cajero: this.idCajero },
      url: process.env.REACT_APP_URL_BACKEND + '/cajeros/detalle'
    }

    RestTunel.makePetition(restArgs, (err, data) => {
      if (err) {
        this.setState({ cajero: {} })
        this.alerta('Error consultando cajero', 'error')
      } else {
        this.setState({ cajero: data })
      }
    })
  }

  queryAccionesRemotas() {
    var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: { id_cajero: this.idCajero },
      url: process.env.REACT_APP_URL_BACKEND + '/cajeroaccionesremotas'
    }

    RestTunel.makePetition(restArgs, (err, data) => {
      if (!err && Array.isArray(data)) {
        this.setState({ accionesRemotas: data })
      }
    })
  }

  // Solo el ultimo registro (mayor id) de cada tipo: Funcionarios, Depositantes, Entidades.
  ultimasAccionesDepositario() {
    const porTipo = {}
    this.state.accionesRemotas
      .filter(a => labelDepositario[a.accion])
      .forEach(a => {
        const prev = porTipo[a.accion]
        if (!prev || Number(a.id) > Number(prev.id)) porTipo[a.accion] = a
      })
    return Object.keys(labelDepositario)
      .map(k => porTipo[k])
      .filter(Boolean)
  }

  // -------- 1) Estado operativo (toggle operacion <-> mantenimiento) --------
  cambiarEstadoOperativo(estadoOperativo) {
    var restArgs = {
      method: 'PATCH',
      headers: 'JSON',
      body: { id_cajero: this.idCajero, estado_operativo: estadoOperativo },
      url: process.env.REACT_APP_URL_BACKEND + '/cajeros/cajero/estadooperativo'
    }

    RestTunel.makePetition(restArgs, (err, data) => {
      if (err) {
        this.alerta('Error actualizando estado operativo', 'error')
      } else {
        this.queryCajero()
        this.alerta('Estado operativo actualizado', 'success')
      }
    })
  }

  // -------- 2) Autorizacion apertura boveda 2FA (toggle autorizado <-> sin autorizar) --------
  autorizarApertura() {
    // login_autorizado es la autorizacion del dashboard (factor humano) que habilita
    // la apertura; el 2do factor es el checktoken del transportador en el cajero.
    var valor = (this.state.cajero.login_autorizado === 1) ? 0 : 1

    var restArgs = {
      method: 'PATCH',
      headers: 'JSON',
      body: { id_cajero: this.idCajero, accion: 'login', valor: valor },
      url: process.env.REACT_APP_URL_BACKEND + '/cajeros/authorize'
    }

    RestTunel.makePetition(restArgs, (err, data) => {
      if (err) {
        this.alerta('Error en la autorización de apertura', 'error')
      } else {
        this.setState(prev => ({
          cajero: {
            ...prev.cajero,
            login_autorizado: data.login_autorizado,
            apertura_autorizada: data.apertura_autorizada
          }
        }))
        this.alerta(data.login_autorizado === 1 ? 'Apertura AUTORIZADA' : 'Autorización retirada', 'success')
      }
    })
  }

  // Click del boton 2FA: para QUITAR la autorizacion va directo; para AUTORIZAR
  // abre el modal que pide la contraseña del usuario.
  onClickAutorizar = () => {
    if (this.state.cajero.login_autorizado === 1) {
      this.autorizarApertura()
    } else {
      this.setState({ modalPasswordOpen: true, accionPassword: 'autorizar', passwordInput: '', passwordError: '' })
    }
  }

  // Click del boton de estado operativo: pasar a MANTENIMIENTO pide contraseña
  // (igual que la autorizacion de apertura); volver a OPERACION va directo.
  onClickEstadoOperativo = () => {
    const enOperacion = this.state.cajero.estado_operativo === 'operacion'
    if (enOperacion) {
      this.setState({ modalPasswordOpen: true, accionPassword: 'mantenimiento', passwordInput: '', passwordError: '' })
    } else {
      this.cambiarEstadoOperativo('operacion')
    }
  }

  cerrarModalPassword = () => {
    this.setState({ modalPasswordOpen: false, accionPassword: null, passwordInput: '', passwordError: '' })
  }

  // Verifica la contraseña (sin tocar BD) y, si es correcta, autoriza la apertura.
  confirmarAutorizacion = () => {
    const password = this.state.passwordInput

    if (!password) {
      this.setState({ passwordError: 'Ingrese la contraseña' })
      return
    }

    this.setState({ verificandoPassword: true, passwordError: '' })

    var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: { password: password },
      url: process.env.REACT_APP_URL_BACKEND + '/cajeros/authorize/verify-password'
    }

    RestTunel.makePetition(restArgs, (err, data) => {
      this.setState({ verificandoPassword: false })
      if (err) {
        this.setState({ passwordError: 'Error verificando la contraseña' })
      } else if (data && data.valido) {
        const accion = this.state.accionPassword
        this.setState({ modalPasswordOpen: false, accionPassword: null, passwordInput: '', passwordError: '' })
        if (accion === 'mantenimiento') {
          this.cambiarEstadoOperativo('mantenimiento')
        } else {
          this.autorizarApertura()
        }
      } else {
        this.setState({ passwordError: 'Contraseña inválida' })
      }
    })
  }

  checkLoginAperturaState() {
    var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: { id_cajero: this.idCajero },
      url: process.env.REACT_APP_URL_BACKEND + '/cajeros/authorize/state'
    }

    RestTunel.makePetition(restArgs, (err, data) => {
      if (!err) {
        this.setState(prev => ({
          cajero: {
            ...prev.cajero,
            login_autorizado: data.login_autorizado,
            apertura_autorizada: data.apertura_autorizada
          }
        }))
      }
    })
  }

  // -------- 3) Actualizar informacion en depositario (funcionarios + clientes + entidades) --------
  actualizarDatosDepositario() {
    const acciones = ['actualizar_funcionarios', 'actualizar_clientes', 'actualizar_entidades']

    this.setState({ enviandoActualizacion: true })

    let pendientes = acciones.length
    let errores = 0

    acciones.forEach((accion) => {
      var restArgs = {
        method: 'PUT',
        headers: 'JSON',
        body: { id_cajero: this.idCajero, accion: accion, parametros: '' },
        url: process.env.REACT_APP_URL_BACKEND + '/cajeroaccionesremotas/new'
      }

      RestTunel.makePetition(restArgs, (err, data) => {
        if (err) errores++
        pendientes--

        if (pendientes === 0) {
          this.setState({ enviandoActualizacion: false })
          this.queryAccionesRemotas()
          if (errores === 0) {
            this.alerta('Actualización enviada al depositario: funcionarios, clientes y entidades', 'success')
          } else {
            this.alerta('Error enviando ' + errores + ' de ' + acciones.length + ' actualizaciones', 'error')
          }
        }
      })
    })
  }

  render() {
    const cajero = this.state.cajero
    const activo = cajero.estado === 'A'
    const enOperacion = cajero.estado_operativo === 'operacion'
    const autorizado = cajero.login_autorizado === 1

    return (
      <Box sx={{ p: { xs: 1, md: 3 } }}>

        <Typography variant="h5" sx={{ fontWeight: 600 }}>Acciones del cajero</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {cajero.alias} {cajero.codigo ? '· ' + cajero.codigo : ''}
        </Typography>

        <Grid container spacing={3}>

          {/* Datos del cajero */}
          <Grid item xs={12} md={4}>
            <Card elevation={4} sx={{ height: '100%', borderRadius: 2 }}>
              <CardHeader avatar={<PointOfSaleIcon color="primary" />} title="Datos del cajero"
                titleTypographyProps={{ variant: 'h6' }} />
              <Divider />
              <CardContent>
                <Stack spacing={0.75}>
                  <Typography variant="body2"><b>Código:</b> {cajero.codigo}</Typography>
                  <Typography variant="body2"><b>Serial:</b> {cajero.serial}</Typography>
                  <Typography variant="body2"><b>Alias:</b> {cajero.alias}</Typography>
                  <Typography variant="body2"><b>Dirección:</b> {cajero.direccion}</Typography>
                  <Typography variant="body2" component="span"><b>Estado:</b>{' '}
                    <Chip size="small" label={activo ? 'Activo' : 'Inactivo'} color={activo ? 'success' : 'default'} />
                  </Typography>
                </Stack>
              </CardContent>
            </Card>
          </Grid>

          {/* 1) Estado operativo */}
          { session.checkPermiso('opcion_cajero_cambiar_estadooperativo') &&
            <Grid item xs={12} md={4}>
              <Card elevation={4} sx={{ height: '100%', borderRadius: 2 }}>
                <CardHeader avatar={<HandymanIcon color="primary" />} title="Estado operativo"
                  titleTypographyProps={{ variant: 'h6' }} />
                <Divider />
                <CardContent>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="body2" color="text.secondary">Actual:</Typography>
                    <Chip label={enOperacion ? 'En operación' : 'En mantenimiento'}
                      color={enOperacion ? 'success' : 'warning'} />
                  </Stack>
                </CardContent>
                <CardActions sx={{ px: 2, pb: 2 }}>
                  <Button fullWidth variant="contained" color={enOperacion ? 'warning' : 'success'}
                    startIcon={<HandymanIcon />}
                    onClick={this.onClickEstadoOperativo}>
                    {enOperacion ? 'Pasar a mantenimiento' : 'Pasar a operación'}
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          }

          {/* 2) Autorizacion apertura boveda (2FA) */}
          { session.checkPermiso('opcion_activar_apertura_cajero') &&
            <Grid item xs={12} md={4}>
              <Card elevation={4} sx={{ height: '100%', borderRadius: 2 }}>
                <CardHeader avatar={<LockOpenIcon color="primary" />} title="Autorización apertura bóveda (2FA)"
                  titleTypographyProps={{ variant: 'h6' }} />
                <Divider />
                <CardContent>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="body2" color="text.secondary">Actual:</Typography>
                    <Chip label={autorizado ? 'Autorizado' : 'Sin autorizar'}
                      color={autorizado ? 'success' : 'default'}
                      icon={autorizado ? <LockOpenIcon /> : <LockIcon />} />
                  </Stack>
                </CardContent>
                <CardActions sx={{ px: 2, pb: 2 }}>
                  <Button fullWidth variant="contained" color={autorizado ? 'error' : 'success'}
                    disabled={!activo}
                    startIcon={autorizado ? <LockIcon /> : <LockOpenIcon />}
                    onClick={this.onClickAutorizar}>
                    {autorizado ? 'Quitar autorización' : 'Autorizar apertura'}
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          }

          {/* 3) Actualizar informacion en depositario */}
          { session.checkPermiso('opcion_cajero_acciones_remotas') &&
            <Grid item xs={12}>
              <Card elevation={4} sx={{ borderRadius: 2 }}>
                <CardHeader avatar={<SyncIcon color="primary" />} title="Actualizar información en depositario"
                  titleTypographyProps={{ variant: 'h6' }}
                  action={
                    <Tooltip title="Refrescar estado">
                      <IconButton onClick={this.queryAccionesRemotas}><RefreshIcon /></IconButton>
                    </Tooltip>
                  } />
                <Divider />
                <CardContent>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Envía al cajero la orden de actualizar <b>funcionarios</b>, <b>depositantes</b> y <b>entidades</b>.
                    Se aplica en el próximo enlace del cajero (~20 s); usá «Refrescar» para ver la respuesta.
                  </Typography>

                  <Button variant="contained" color="primary" startIcon={<SendIcon />}
                    disabled={this.state.enviandoActualizacion}
                    onClick={this.actualizarDatosDepositario} sx={{ mb: 2 }}>
                    {this.state.enviandoActualizacion ? 'Enviando…' : 'Enviar'}
                  </Button>

                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell><b>Dato</b></TableCell>
                        <TableCell><b>Fecha solicitud</b></TableCell>
                        <TableCell><b>Respuesta</b></TableCell>
                        <TableCell><b>Fecha respuesta</b></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {
                        this.ultimasAccionesDepositario()
                          .map(a => (
                            <TableRow key={a.id}>
                              <TableCell>{labelDepositario[a.accion]}</TableCell>
                              <TableCell>{a.fecha_creacion}</TableCell>
                              <TableCell>
                                {a.fecha_respuesta
                                  ? <Chip size="small" color="success" label={a.respuesta || 'Confirmado'} />
                                  : <Chip size="small" color="warning" label="Pendiente" />}
                              </TableCell>
                              <TableCell>{a.fecha_respuesta || '—'}</TableCell>
                            </TableRow>
                          ))
                      }
                      {
                        this.ultimasAccionesDepositario().length === 0 &&
                        <TableRow>
                          <TableCell colSpan={4} align="center" sx={{ color: 'text.secondary' }}>
                            Sin solicitudes registradas
                          </TableCell>
                        </TableRow>
                      }
                    </TableBody>
                  </Table>
                </CardContent>
              </Card>
            </Grid>
          }

        </Grid>

        <Dialog open={this.state.modalPasswordOpen} onClose={this.cerrarModalPassword} maxWidth="xs" fullWidth>
          <DialogTitle>
            {this.state.accionPassword === 'mantenimiento'
              ? 'Confirmar paso a mantenimiento'
              : 'Confirmar autorización de apertura'}
          </DialogTitle>
          <DialogContent>
            <DialogContentText sx={{ mb: 2 }}>
              {this.state.accionPassword === 'mantenimiento'
                ? 'Ingresá tu contraseña de acceso al servidor para pasar el cajero a mantenimiento.'
                : 'Ingresá tu contraseña de acceso al servidor para autorizar la apertura de la bóveda.'}
            </DialogContentText>
            <TextField
              autoFocus
              fullWidth
              type="password"
              label="Contraseña"
              value={this.state.passwordInput}
              onChange={(e) => this.setState({ passwordInput: e.target.value, passwordError: '' })}
              onKeyDown={(e) => { if (e.key === 'Enter') this.confirmarAutorizacion() }}
              error={!!this.state.passwordError}
              helperText={this.state.passwordError || ' '}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.cerrarModalPassword} disabled={this.state.verificandoPassword}>Cancelar</Button>
            <Button variant="contained" color="success" onClick={this.confirmarAutorizacion}
              disabled={this.state.verificandoPassword}>
              {this.state.verificandoPassword
                ? 'Verificando…'
                : (this.state.accionPassword === 'mantenimiento' ? 'Pasar a mantenimiento' : 'Autorizar')}
            </Button>
          </DialogActions>
        </Dialog>

        <Snackbar open={this.state.mostrarAlerta} onClose={this.handleCloseAlert} autoHideDuration={3000}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Collapse in={this.state.mostrarAlerta}>
            <Alert severity={this.state.severidadAlerta || 'info'} onClose={this.handleCloseAlert} sx={{ width: '100%' }}>
              <AlertTitle>{(this.state.severidadAlerta || 'info').toUpperCase()}</AlertTitle>
              {this.state.mensajeAlerta}
            </Alert>
          </Collapse>
        </Snackbar>

      </Box>
    )
  }
}

export default CajerosAccionesRemotas
